<!--
 * @Author: 王佳宾
 * @Date: 2022-10-13 10:23:44
 * @LastEditors: chenmengnan
 * @LastEditTime: 2026-07-08 15:29:54
 * @Description: 数据管理弹窗背景
 * @FilePath: \web\src\components\lib\Modal\modal1.vue
-->
<template>
  <a-modal v-model:visible="option.visible" wrap-class-name="default1-modal" :centered="true" :footer="null"
    :getPopupContainer="(triggerNode) => triggerNode.parentNode" :closable="false" :destroyOnClose="true"
    :maskClosable="false" :width="option.width || '5.4rem'">
    <section class="default1-modal-head">
      {{ option.title }}
      <i class="iconfont icon-cuowu error"
        style="color: #dd1414; cursor: pointer; font-size: 0.4rem; line-height: 0.2rem" title="关闭"
        @click="closeModal"></i>
    </section>
    <!-- 头 -->
    <section class="default1-modal-main">
      <slot name="main"></slot>
    </section>
    <!-- 内容 -->
    <section class="default1-modal-foot" v-if="option.notFootertype === 'downLoad'">
      <div class="confirm" @click="confirmModal">下载</div>
    </section>
    <section class="default1-modal-foot" v-if="!option.notFooter && !option.notFootertype">
      <div class="close" @click="closeModal">取消</div>
      <div class="confirm" @click="confirmModal">确认</div>
    </section>
    <!-- btn -->
  </a-modal>
</template>

<script setup>
import { onMounted, ref, reactive, getCurrentInstance, defineProps, defineEmits, } from 'vue';
const props = defineProps({
  option: {
    type: Object,
  },
});

const emit = defineEmits(['close', 'confirm',]);
/**
 * @description 取消
 */
const closeModal = () => {
  emit('close');
};

/**
 * @description 确认
 */
const confirmModal = () => {
  emit('confirm');
};

</script>

<style lang="scss">
.default1-modal {
  z-index: 1000;

  .ant-modal {}

  .ant-modal-content {
    background-color: transparent;
    background: url(~@/static/images/dataManagement/modal.png) no-repeat;
    background-size: 100% 100%;
    // width: 5.4rem;

    .ant-modal-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
      min-height: 1.5rem;
      color: #fff;

      /* 头 */
      .default1-modal-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.2rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
      }

      /* 主体 */
      .default1-modal-main {
        margin: 0.1rem 0;
        max-height: 7rem;
        overflow-y: auto;
        overflow-x: hidden;
        position: relative;

        .ant-input {
          padding: 0.1rem;
          background-color: transparent;
          border-color: #695933;
          font-size: 0.16rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 0.16rem;

          &::placeholder {
            font-size: 0.14rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            line-height: 0.14rem;
            opacity: 0.4;
          }
        }

        .ant-input-number {
          background-color: transparent;
          border-color: #695933;
          color: #ffffff;
        }

        .ant-input-password .ant-input-affix-wrapper {
          background-color: transparent;
        }

        .pdf_download {
          position: absolute;
          top: .5rem;
          left: 2rem;
        }

        .img_ky_bg {
          width: 9.5rem;
        }
      }

      /* 尾部 */
      .default1-modal-foot {
        display: flex;
        justify-content: flex-end;
        margin-top: 0.1rem;

        div {
          width: fit-content;
          padding: 0.1rem 0.3rem;
          cursor: pointer;
          user-select: none;

          &:active {
            opacity: 0.7;
          }
        }

        .close {
          margin-right: 0.1rem;
          background-image: url(~@/static/images/dataManagement/reset_btn.png);
          background-size: 100% 100%;
        }

        .confirm {
          background-image: url(~@/static/images/dataManagement/submit_btn.png);
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
